import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=c2aeb55c"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2aeb55c')) {
      api.createRecord('c2aeb55c', component.options)
    } else {
      api.reload('c2aeb55c', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=c2aeb55c", function () {
      api.rerender('c2aeb55c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/elements/Checkbox.vue"
export default component.exports